import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import CreateDeposit from 'components/booking/CreateDeposit.component';
import ELID from 'constants/elid.const';
import { selectCurrentSalonClientsArray } from 'selectors/currentSalon.selectors';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import { fromPropsToIsWeek } from 'utils/converters/props/path.util';

import AddAnotherService from 'booking/components/AddAnotherService';
import AppointmentLoading from 'booking/components/AppointmentLoading';
import BookTimeOff from 'booking/components/BookTimeOff';
import CustomerPicker from 'booking/components/CustomerPicker';
import EditBooking from 'booking/components/EditBooking';
import EventLoading from 'booking/components/EventLoading';
import FrequentlyBooked from 'booking/components/FrequentlyBooked';
import ServiceCategory from 'booking/components/ServiceCategory';
import ServiceSelection from 'booking/components/ServiceSelection';
import AddNewClient from 'booking/mappers/AddNewClientContainer';
import CreateVoucher from 'booking/mappers/CreateVoucherContainer';
import RepeatBooking from 'booking/mappers/RepeatBookingContainer';
import StatefulRoute from 'lib/StatefulRoute';
import { setCreation, setModal } from 'scheduler/actions';

const BookingRouter = (props) => {
  const { match, salonId, setModal, setCreation } = props;

  const isWeek = fromPropsToIsWeek(props);
  const appointmentId = fromAnyToInteger(match.params.appointmentId) || 0;
  const eventId = fromAnyToInteger(match.params.eventId) || 0;

  const newBooking = isWeek
    ? `/salon/${salonId}/week/:dateString/:stylistId/appointment/new`
    : `/salon/${salonId}/day/:dateString/appointment/new`;

  const oldBooking = isWeek
    ? `/salon/${salonId}/week/:dateString/:stylistId/appointment/edit/${appointmentId}`
    : `/salon/${salonId}/day/:dateString/appointment/edit/${appointmentId}`;

  const offTime = isWeek
    ? `/salon/${salonId}/week/:dateString/:stylistId/event/edit/${eventId}`
    : `/salon/${salonId}/day/:dateString/event/edit/${eventId}`;

  const handleMount = useCallback(() => {
    setModal(false);
    setCreation(false);
  }, [setCreation, setModal]);

  const handleUnmount = useCallback(() => {
    setModal(true);
    setCreation(true);
  }, [setCreation, setModal]);

  return (
    <section data-bem="BookingRouter" className="booking-steps-from-checkout" id={ELID.bookside}>
      <StatefulRoute
        exact
        path={newBooking}
        component={CustomerPicker}
        onDidMount={handleMount}
        onWillUnmount={handleUnmount}
      />

      <Route path={`${newBooking}/timeoff`} component={BookTimeOff} />

      <Route exact path={`${newBooking}/client`} component={AddNewClient} />
      <Route path={`${newBooking}/create/:name/client`} component={AddNewClient} />
      <Route path="/salon/:salonId/day/:dateString/create/new/client/new/" component={AddNewClient} />
      <Route path="/salon/:salonId/day/:dateString/createvoucher" component={CreateVoucher} />
      <Route path="/salon/:salonId/week/:dateString/:stylistId?/create/new/client/new/" component={AddNewClient} />
      <Route path={`${newBooking}/frequently-booked`} component={FrequentlyBooked} />
      <Route exact path={`${newBooking}/services`} component={ServiceSelection} />
      <Route path={`${newBooking}/services/:category`} component={ServiceCategory} />
      <Route path={`${newBooking}/deposit`} component={CreateDeposit} />
      <Route path={`${newBooking}/repeatbooking`} component={RepeatBooking} />
      <Route path={`${newBooking}/addanotherservice`} component={AddAnotherService} />
      <Route path={`${newBooking}/select`} component={CustomerPicker} />

      <Route path={`${oldBooking}/addanotherservice`} component={AddAnotherService} />
      <Route exact path={`${oldBooking}/summary`} component={EditBooking} />
      <Route path={`${oldBooking}/summary/:category`} component={ServiceCategory} />
      <Route path={`${oldBooking}/services/:category`} component={ServiceCategory} />
      <Route path={`${oldBooking}/load`} component={AppointmentLoading} />
      <Route path={`${oldBooking}/frequently-booked`} component={FrequentlyBooked} />
      <Route path={`${oldBooking}/select`} component={CustomerPicker} />

      <Route path={`${oldBooking}/deposit`} component={CreateDeposit} />
      <Route path={`${oldBooking}/repeatbooking`} component={RepeatBooking} />
      <Route path={`${offTime}/load`} component={EventLoading} />
      <Route path={`${offTime}/timeoff`} component={BookTimeOff} />
    </section>
  );
};

const mapStateToProps = (state) => ({
  clientList: selectCurrentSalonClientsArray(state),
  currentStylistId: state.booking.currentStylistId,
  salonId: state.currentSalon.id,
  services: state.currentSalon.services,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ setCreation, setModal }, dispatch);

const BookingRouterHoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(BookingRouter));

// noinspection JSUnusedGlobalSymbols
export default BookingRouterHoc;
